// SportsMixin.ts

import { Component, Vue } from 'vue-property-decorator';
import { SportModel } from '@/models/sport';
import { sportStore } from '@/store';

@Component
export class SportsMixin extends Vue {

	allSports: Array<SportModel> = [];
	isSportsLoaded: boolean = false;
	isSportsLoading: boolean = false;

    async created() {
        await this.loadAllSports();
    }

    async loadAllSports() {
        if( this.allSports.length > 0 ) return;
        
        this.isSportsLoaded = false;
        this.isSportsLoading = true;
        this.allSports = await sportStore.loadSports()
        this.isSportsLoading = false;
        this.isSportsLoaded = true;
    }
}